// export * from './flight-details-baggage/flight-details-baggage.component';
// export *  from './flight-details-fare/flight-details-fare.component';
// export *  from './flight-details-itinerary/flight-details-itinerary.component';
export * from './flight-details.component';
// export * from './send-itinerary/send-itinerary.component';